import WebLayout from "../layout/WebLayout";
import React, { useEffect, useState } from "react";
import { useProductDetailsFetch } from "../hooks/useProductDetailsFetch";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import * as cartActions from "../store/action/cart";
import { toastMessage } from "../utils/Message";
import Loader from "../components/Loader";
import CityModal from "../components/modal/CityModal";

function ProductDetails() {
  const { storeCity } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(true); // शुरुआत में true सेट करें
  const [isDataLoaded, setIsDataLoaded] = useState(false); // नया स्टेट जोड़ें

  const startIndex = 0;
  const [previewImage, setPreviewImage] = useState("");
  const type = "";

  const location = useLocation();
  const imagesToShow = 5;

  const searchParams = new URLSearchParams(location.search);
  const { productDetails, loading, error } = useSelector(
    (state) => state.product
  ); // मान लें कि आपके product reducer में loading और error स्टेट हैं

  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [stockAvailability, setStockAvailability] = useState(false);
  const [cityModal, setCityModal] = useState(false);
  const [showClose, setShowClose] = useState(false);

  const queryProductId = searchParams.get("product_id");
  const { slug } = useParams();

  useProductDetailsFetch(
    slug,
    queryProductId,
    selectedSize,
    selectedColor,
    type
  );

  useEffect(() => {
    // जब डेटा लोड हो जाए तो isLoader को false करें
    if (productDetails && !loading) {
      setIsLoader(false);
      setIsDataLoaded(true);
    }
  }, [productDetails, loading]);

  const visibleImages =
    productDetails?.product_image?.slice(
      startIndex,
      startIndex + imagesToShow
    ) || [];

  const cartAdd = async () => {
    if (!storeCity) {
      setCityModal(true);
      return false;
    }
    setIsLoader(true);
    try {
      await dispatch(
        cartActions.cartAdd(
          productDetails.id,
          selectedColor,
          selectedSize,
          productDetails.isVariant
        )
      );
      setIsLoader(false);
      toastMessage(
        "Product successfully added to cart",
        "success",
        "top-center",
        2000
      );
      navigate(`/seller-product-list/${productDetails.seller}`);
    } catch (e) {
      toastMessage(e.message, "danger", "top-center", 5000);
      setIsLoader(false);
    }
  };

  useEffect(() => {
    setSelectedColor("");
    setSelectedSize("");
    if (productDetails?.product_image?.length > 0) {
      setPreviewImage(productDetails.product_image[0].product_image);
    }
    if (productDetails?.selectedSize) {
      setSelectedSize(productDetails.selectedSize);
    }
    if (productDetails?.selectedColor) {
      setSelectedColor(productDetails.selectedColor);
    }
    if (productDetails?.productAvailablility) {
      setStockAvailability(true);
    } else {
      setStockAvailability(false);
    }
  }, [
    productDetails?.productAvailablility,
    productDetails?.product_image,
    productDetails?.selectedColor,
    productDetails?.selectedSize,
  ]);

  const viewStore = `/seller-product-list/${productDetails?.seller}`;

  if (isLoader || !isDataLoaded) {
    return <Loader />;
  }

  return (
    <WebLayout pageName={ProductDetails}>
      <section className="product-details py-40">
        <CityModal
          cityModal={cityModal}
          setCityModal={setCityModal}
          showClose={showClose}
        />
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-lg-9">
              <div className="row gy-4">
                <div className="col-xl-6">
                  <div className="product-details__left">
                    <div className="product-details__thumb-slider border border-gray-100 rounded-16">
                      {visibleImages.map((imageUrl, index) => (
                        <div
                          className="product-details__thumb flex-center h-100"
                          key={index}>
                          <img
                            src={imageUrl.product_image}
                            alt={`${index + 1}`}
                            onClick={() =>
                              setPreviewImage(imageUrl.product_image)
                            }
                          />
                        </div>
                      ))}
                    </div>

                    <div className="mt-24">
                      <div className="product-details__images-slider">
                        <div>
                          <div className="max-w-120 max-h-120 h-100 flex-center border border-gray-100 rounded-16 p-8">
                            <img src={previewImage} alt={previewImage} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="product-details__content">
                    <h5 className="mb-12">{productDetails.name}</h5>
                    <div className="flex-align flex-wrap gap-12">
                      <span className="text-gray-400">
                        Product code : {productDetails.productCode}
                      </span>
                    </div>
                    <span className="mt-20 pt-20 text-gray-700 border-top border-gray-100 d-block"></span>

                    <div className=" flex-align flex-wrap gap-32">
                      <div className="flex-align gap-8">
                        <h4 className="mb-0 text-danger">
                          <del>MRP : ₹{productDetails.mrp}</del>
                        </h4>
                        &emsp;
                        <h4 className="mb-0 text-success">
                          ₹{productDetails.selling_price}
                        </h4>
                        &emsp;
                        <h6
                          className="mb-0 bg-success text-white p-4 px-10"
                          style={{ borderRadius: 20 }}>
                          {productDetails.discount}% Off
                        </h6>
                      </div>
                    </div>

                    <span className="mt-20 pt-20 text-gray-700 border-top border-gray-100 d-block"></span>
                    {productDetails.stock_status === "AVAILABLE" ? (
                      <div className="flex-between gap-16 flex-wrap mb-12">
                        <div className="flex-align flex-wrap gap-16">
                          {productDetails.cart ? (
                            <button
                              onClick={() => navigate("/cart")}
                              className="btn btn-main rounded-pill flex-align d-inline-flex gap-8 px-48 py-16">
                              <i className="ph ph-shopping-cart"></i> Go to Cart
                            </button>
                          ) : (
                            <div className="border-b py-2">
                              {stockAvailability ? (
                                <button
                                  onClick={() => cartAdd()}
                                  className="btn btn-main rounded-pill flex-align d-inline-flex gap-8 px-48 py-16">
                                  <i className="ph ph-shopping-cart"></i> Add to
                                  Cart
                                </button>
                              ) : (
                                <button
                                  disabled={!stockAvailability}
                                  onClick={() => cartAdd()}
                                  className="btn btn-main rounded-pill flex-align d-inline-flex gap-8 px-48 py-16">
                                  <i className="ph ph-shopping-cart"></i> Add to
                                  Cart
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <p
                        className="text-danger mb-2"
                        style={{ fontWeight: "700" }}>
                        Out of Stock
                      </p>
                    )}
                    <div className="pt-10">
                      <div className="product-dContent border rounded-10">
                        <div className="product-dContent__header border-bottom border-gray-100 flex-between flex-wrap gap-5 p-10">
                          <ul
                            className="nav common-tab nav-pills mb-3"
                            id="pills-tab"
                            role="tablist">
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link active"
                                id="pills-description-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-description"
                                type="button"
                                role="tab"
                                aria-controls="pills-description"
                                aria-selected="true">
                                Description
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link"
                                id="pills-specifications-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-specifications"
                                type="button"
                                role="tab"
                                aria-controls="pills-specifications"
                                aria-selected="false">
                                Specifications
                              </button>
                            </li>
                          </ul>
                        </div>
                        <div className="product-dContent__box p-20">
                          <div className="tab-content" id="pills-tabContent">
                            <div
                              className="tab-pane fade show active"
                              id="pills-description"
                              role="tabpanel"
                              aria-labelledby="pills-description-tab"
                              tabindex="0">
                              <div
                                className="text-gray-700 "
                                dangerouslySetInnerHTML={{
                                  __html: productDetails.description,
                                }}
                              />
                            </div>
                            <div
                              className="tab-pane fade"
                              id="pills-specifications"
                              role="tabpanel"
                              aria-labelledby="pills-specifications-tab"
                              tabindex="0">
                              <div
                                className="text-gray-700 "
                                dangerouslySetInnerHTML={{
                                  __html: productDetails.product_specification,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="product-details__sidebar border border-gray-100 rounded-16 overflow-hidden">
                <div className="p-24">
                  <div className="flex-between bg-main-600 rounded-pill p-8">
                    <div className="flex-align gap-8">
                      <span className="w-44 h-44 bg-white rounded-circle flex-center text-2xl">
                        <i className="ph ph-storefront"></i>
                      </span>
                      <span className="text-white">
                        {productDetails?.seller_name}
                      </span>
                    </div>
                    <a
                      href={viewStore}
                      className="btn btn-white rounded-pill text-uppercase">
                      View inventory
                    </a>
                  </div>
                </div>
                <div className="p-24 bg-color-one d-flex align-items-start gap-24 border-bottom border-gray-100">
                  <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                    <i className="ph-fill ph-truck"></i>
                  </span>
                  <div className="">
                    <h6 className="text-sm mb-8">Fast Delivery</h6>
                    <p className="text-gray-700">
                      Lightning-fast shipping, guaranteed.
                    </p>
                  </div>
                </div>
                <div className="p-24 bg-color-one d-flex align-items-start gap-24 border-bottom border-gray-100">
                  <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                    <i className="ph-fill ph-check-circle"></i>
                  </span>
                  <div className="">
                    <h6 className="text-sm mb-8">
                      Pickup available at Shop location
                    </h6>
                    <p className="text-gray-700">Usually ready in 24 hours</p>
                  </div>
                </div>
                <div className="p-24 bg-color-one d-flex align-items-start gap-24 border-bottom border-gray-100">
                  <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                    <i className="ph-fill ph-package"></i>
                  </span>
                  <div className="">
                    <h6 className="text-sm mb-8">Packaging</h6>
                    <p className="text-gray-700">
                      Research & development value proposition graphical user
                      interface investor.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </WebLayout>
  );
}

export default ProductDetails;
